module.exports = __webpack_public_path__ + "img/logo-login.f27f9cf1.png";